import * as React from 'react';

export function ErrorIllustration(): React.JSX.Element {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 700 450"
            xmlSpace="preserve"
        >
            <rect fill="#2CACE3" width="700" height="450" />
            <path
                fill="#FD7FA1"
                d="M298,417.8c-0.3-4.7-2.7-7.6-6.3-9c0.9,0,1.8-0.1,2.8-0.2c-3-4.3-6.7-7.4-10.4-10.3c1.2-0.1,1.8-0.9-0.4-2.1
            c-0.2,0-0.5,0-0.7,0c0.4-0.3,0.3-0.9-0.9-2c-3-2.4-5.8-5.2-9.4-6.6c0.4,0.6,0.9,1.2,1.3,1.8c-1.7-1.9-3.3-4-4.6-6.4
            c0.4,1.1,0.7,2.2,1,3.3l-1.4-0.9c-0.3-0.8-0.6-1.7-1-2.5c0.4,0,0.9,0.1,1.3,0.1c-1.2-7.4-6.3-14.4-10.7-20.4c0,0.2,0,0.4,0,0.7
            c0-0.1-0.1-0.1-0.1-0.2c-0.6-0.7-1.3-1.3-2-1.9c-2.9-7.5-13.1-14.9-20.8-21.2c0,0,0,0,0,0c-39-28.9-92.1-29.2-134.7-47.6
            c0.1,0,0.2,0,0.2,0c-2.3-1-4.5-2-6.8-3.1c-0.8-0.4-1.6-0.8-2.3-1.1c0,0,0,0,0,0c-2.7-2-5.9-4.1-8.7-5.6c-0.5-0.4-1.1-0.8-1.6-1.3
            c0.2,0,0.4,0.1,0.5,0.1c-0.6-0.5-1.1-1.4-1.6-1.1c-9.3-8.8-15.2-23.9-21-33.5c0.6-0.1,1.3-0.5,2-1c-0.4-6.8-1.1-26.9-3.4-14.7
            c0-0.4-0.1-0.7-0.1-1.1c1-3.2,2.2-4.8,2.9-0.6c1-6.4,2.9-12.5,5.9-18.3c-0.4,0.3-0.9,0.6-1.3,0.9c12.4-18.9,26.3-19.4,40.7-2.8
            c18.3-10.6,34.5,0.6,42.9,18.2c0.5-1.6,0.4-3.1,0-4.4c0.1,0.1,0.2,0.2,0.3,0.4c0,0,0,0,0,0c0,0,0,0,0,0c3.8,19,5.9,39.1,9.9,58.2
            l0,0c18.5,25,38.9-11.8,34.1-30.9c1.3-13-5.5-25.2-14.7-35.6c-5.1-9.4-11.8-11.3-17.6-8.8c1.6-1.8,2.4-4.1,1-5.9
            c-1.6-1.7-3.3-3.3-4.8-4.9c3.3,2.9,7.2,5.5,5,9.3c2-0.9,2.1-2.4,1.3-4.1c2.4,2.5,2.8,1.9-1.4-4.7c-13.8-17.6-14.1-52-41.1-55
            c-52.7-2.9-115.4,38.4-108.6,95.5c-0.2,0.7-0.4,1.4-0.6,2.1c-0.1-1.4-0.3-2.8-0.4-4.2c-0.8,33.9,18.5,69.3,45.8,86.6
            c0,0-0.1,0-0.1,0.1c0.6,0.4,1.1,0.7,1.7,1.1c0,0,0-0.1,0-0.1c0.1,0,0.2,0.1,0.2,0.1c34.3,26.2,89.2,29.5,108.6,71.7
            c-30.1,17.1-70.3,29.9-107.3,44.1c-10,3.9-19.8,7.8-29.1,12h12.6h32.4H139c16.5-0.2,33-0.4,48.9,0h0.1h25.8h16.5h5.3
            c20.1,0,40.2,0,60.3,0c0.8-4,1.8-8,2.5-12C299.5,431.3,300.1,424.6,298,417.8z M154,188.7c-0.1,0.3-0.1,0.6-0.2,0.8
            c-0.1-0.4-0.1-0.8-0.2-1.3C153.7,188.3,153.8,188.5,154,188.7z M146.3,174.7C146.3,174.7,146.3,174.7,146.3,174.7
            C146.3,174.7,146.3,174.7,146.3,174.7C146.3,174.7,146.3,174.7,146.3,174.7C146.3,174.7,146.3,174.7,146.3,174.7z M145.4,215.4
            c0.5,1,0.9,2.2,1.4,3.3c-0.8-1.1-1.6-2.3-2.2-3.5C144.8,215.2,145.1,215.3,145.4,215.4z M19,265.4c0-0.1,0-0.1-0.1-0.1
            C19,265.3,19,265.4,19,265.4C19.1,265.4,19.1,265.4,19,265.4L19,265.4z M58.3,233.2c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.2-0.3
            C58.4,233,58.3,233.1,58.3,233.2z M58.9,232.3c0.7-0.7,0.9,0.6,0.8,2.2C59.6,233.1,59.3,232.2,58.9,232.3z M298,420.5
            c0,0.4,0,0.8-0.1,1.2c0-0.1,0-0.1,0-0.2C297.9,421.1,297.9,420.8,298,420.5z M295.8,417.3c0.2-1.2,0.2-2.1,0-3
            c0.6,2.2,0.1,4.7-1.7,5.6c0,0,0-0.1,0-0.1C295,419.3,295.6,418.4,295.8,417.3z M295.1,412.4c-0.9-1.2-2.2-1.9-3.8-2.3
            C292.9,410.1,294.2,411.1,295.1,412.4z"
            />
            <path
                fill="#FFFFFF"
                d="M587.7,65.2c3.2-10.3,0.5-20.3-2.3-31.6C640.4,73,661.9,143.4,641.3,207c1.7,10.5-17.4,39.1-3.9,35.8
            c8-28,15.5-56.6,19.2-85.5c0.9-52.2-34.9-96.5-64.7-133c10.6-0.1,25.4,12.1,32.2-0.4C558.2,14.8,573.5-1.3,587.7,65.2z"
            />
            <g>
                <path
                    fill="#277691"
                    d="M168.3,394c-19-54.7-107.2-23.2-124.9-84c-16.1-16.4-27-38.4-30.4-61.4c-1-12.5-11.5,9.5-13,13.9
                c2.1,32.2-8.7,69,16.4,94.6c24.5,26.8,60.9,37.7,92.7,53.6c12.2,9.6,24.8-2.8,38.1-6.2l0,0C153,401.5,167.7,401.1,168.3,394z
                 M53.1,331.4C53.1,331.3,53.1,331.3,53.1,331.4C53.2,331.3,53.2,331.4,53.1,331.4C53.1,331.4,53.1,331.4,53.1,331.4z M89,352.4
                C88.8,352.3,88.8,352.2,89,352.4L89,352.4z"
                />
                <path
                    fill="#277691"
                    d="M61.2,245.3c-2.3,11.7,8.3,12.8,15.2,18.5c2.7,3.9,6.1,8.6,11.1,4.9c21.1-11.5,38.3,16,39.9,33.1
                c28.2,9.6,53.8,18.1,27.8-21c-3.1-7.6-12.4-13.7-18.1-20.9c-12.2-15.7-13.3-39.5-31.3-50.6C80,197.8,50.2,214.7,61.2,245.3z"
                />
            </g>
            <path
                fill="#FC6585"
                d="M295.8,450c2.1-10.8,5.6-21.6,2-32.7c0.7,7.5-0.9,10-8.7,9.4c-4.2-1.8-7.6,0.7-11.3-1.7
            c-8,0.5-10.8,7.1-16,11.9c-8.9,4.3-18.9,6.6-26.3,13.1C255.6,450,275.7,450,295.8,450z"
            />
            <path
                fill="#FDA5BF"
                d="M262,421.3c1.4-7.8-10.2-5.6-14-3.4c-0.3,2.9-3,2.4-4.6,3.2C140.1,455.2,203.3,463.4,262,421.3z M228.3,434.7
            L228.3,434.7c1.1,5.8-20.1,9.7-17.6,5.5c1.3-2.5,6-2.8,7.5-4.2c1.1-2.8,2.5-1.7,3.8-1.1C224.1,429.3,235.3,434.7,228.3,434.7z"
            />
            <path
                fill="#FDA5BF"
                d="M235.4,340c-25.8-12.8-58-22.2-88.5-27.2c-26.5,2.2-51.6-7-75.3-19.4c-7.9-1.7-8.1-10-14.7-14.7
            c-4.2-5.6-10.5-10.6-13.1-17c0.2-2.5-0.2-2.9-2.7-2.5c-3.1,0.8,0.1-2.2-0.2-3.7c0-1.3-0.9-2.6-1.5-3.8c-8.7,0.6,2.8-3.2-3.3-7.9
            c-7-3.9-5.7-13.1-6.5-20c-2.4-2.5-2.2-3.8,1-5.3c-3.2-2.9,0.1-4.3,1.5-6.2c-4.5-2.5,7.1-17.2-1.8-12.9
            c-38.1,92.9,57.5,119.1,124.4,141.7c3.9,2.9,7.1,7,11.4,9.1c1.9,9.6,13.2,12.5,13.7,22.7c6,1.7,6,14.6,12.7,11.3
            c4.7,5.9,39.6-6.2,47.5,3.6c-25.2,4,15.6,1.7,23.7,6.7c3.2-1.5,5.8,0.2,8.6,1c1.4-6.4-4.3-15.1-13.6-11.9
            c-11.3,3.5-20.8-14.9-17.7-24c7.5-0.9,9.4,7.2,14.6,10.9C261.7,359.7,246.3,348.8,235.4,340z M215,371.8
            c-3.6,21.3-32.5-16.1-31.5-24.4C188.5,339.3,213.4,363.6,215,371.8z M36.6,264.2c8.1,12.6,18.1,22.6,29,31.2
            c4.4,3.5,20.8,8.3,11.4,12.4c-17.5-8.1-34.4-21.2-43.8-39.8c-1.4-3.6-7.3-18.2,0-14.1C31.5,256.4,38,261.5,36.6,264.2z M262.9,393
            c0.8-0.7,1-0.8,1.5-0.1C263.8,393.6,263.7,393.7,262.9,393z M242.2,385.3c0.2,0.3,0.2,0.6-0.2,0.5
            C241.7,385.6,241.9,385.3,242.2,385.3z"
            />
            <path
                fill="#FDD9EC"
                d="M258.5,364.6c-7.8,13-3.8-6-17.3-5.3c-3.6,6.3,2.7,13.3,5.5,18.9c4.6,9.6,14.2,3.6,22.5,4.9l0,0
            c-1.2-7.4-6.3-14.4-10.8-20.4c0.1,0.7-0.1,1.5,0.1,2.2C258.5,364.7,258.5,364.7,258.5,364.6z"
            />
            <path
                fill="#FDD9EC"
                d="M269.2,383c5.6,16.5,4.4,27.6,25.2,25.6C286.9,398.1,275.3,394.5,269.2,383L269.2,383z"
            />
            <path fill="#FC6585" d="M272.5,387.7c2.7,3.5,4.3,7.9,9.4,6.6C279,391.8,276.2,389,272.5,387.7z" />
            <path
                fill="#FDA5BF"
                d="M269.2,383c0.4,0,0.7,0,1.1,0c-0.3-0.4-0.6-0.8-0.9-1.2C269.3,382.3,269.3,382.6,269.2,383z"
            />
            <path
                fill="#FDA5BF"
                d="M140.7,205.5c4.8-3.6,3-6.8-0.3-10.7c-11.1-14.2,15.5-4.5,5.8-20.2c-1-6.1-6.4-10.3-8-15.5
            c0.3-2.6-2.6-2.5-3.5-4.8c-1.7-3.4-5.1-2.3-6.5-3.7c1.4-5.6-4.6-1.3-7.3-3.2c-2.2-1.4-3-0.6-3.7,1.4c-2,1.4-5.6-1.5-8.2,1.2
            c26.6,3.5,1.8,28.9,14.1,31.7c1.5,2.1,7.7,2.1,5.8,5.2C128.3,195.2,138.7,197.5,140.7,205.5z"
            />
            <path
                fill="#FDD9EC"
                d="M117.4,180c16.4-20.5-10.1-42.6-26.4-20.8C78.7,177.3,104.1,202.8,117.4,180z M112.7,170.7
            c-1.6,4.5-6,12.8-12.9,8.9C82,166.6,116.4,145.8,112.7,170.7z"
            />
            <path fill="#FDD9EC" d="M295.8,417.3c1.5-7.9-6.6-7.4-12.2-8.2C271.2,411.3,290,423.2,295.8,417.3z" />
            <path fill="#FDA5BF" d="M279.9,408.2c-1.6-4.9-7.2-6.5-7.1-12.4C265.1,397.9,274.2,412.6,279.9,408.2z" />
            <path
                fill="#FDA5BF"
                d="M246.2,432.2c8.3,4.7,27.5-17.2,7.6-5.1c-0.2,0.2-0.3,0.3-0.5,0.5c-1.1,0.7-2.6,1.1-3.6,2c-0.6,0.3-1.4,0.7-2,1
            C247.2,431.1,246.7,431.6,246.2,432.2z"
            />
            <path fill="#FDA5BF" d="M154.3,187.7c-3.6,7.5,12,10.4,8.1,17.3C168.9,201.8,154.9,193.2,154.3,187.7z" />
            <path fill="#FDA5BF" d="M295.8,417.3c-5.9,3.2-11.1,0.9-15.8-3.1C280.7,419.9,294.9,423.6,295.8,417.3z" />
            <path fill="#FC6585" d="M254.9,426.5c5-1.9,18.1-10.2,7.1-5.1C259.9,423.4,256.2,423.9,254.9,426.5z" />
            <path fill="#FC6585" d="M101,292.5c-3.1-1.4-6.1-2.8-9.2-4.1C93.1,291.5,97.8,292.2,101,292.5z" />
            <path fill="#FDA5BF" d="M150.6,184.1c-0.2,2.2,0.9,3,3,2.9C152.6,186.1,151.6,185.1,150.6,184.1z" />
            <path
                fill="#FC6585"
                d="M246.2,432.2c0.5-0.5,1-1,1.5-1.6c-1.2,0.8-2.4,1.7-3.6,2.5C244.9,433.2,245.5,432.5,246.2,432.2z"
            />
            <path fill="#FC6585" d="M11.5,228.6c0.1,1.8,0.3,3.6,0.4,5.4C11.8,232.2,11.7,230.4,11.5,228.6z" />
            <path fill="#FDA5BF" d="M244.6,433.1c-0.8-0.1-0.9,1-1.3,1.6C244.7,435.5,244.4,434.2,244.6,433.1z" />
            <path fill="#FC6585" d="M268.8,417.4c-0.7,0.4-1.4,0.7-0.2,0.9C268.9,418.2,269.1,417.7,268.8,417.4z" />
            <path fill="#FC6585" d="M247.7,430.6c0.7-0.3,1.4-0.7,2-1C249.1,429.9,248.4,430.2,247.7,430.6z" />
            <path fill="#FC6585" d="M251.3,428.5c0.7-0.3,1.4-0.7,2-1C252.7,427.9,252,428.2,251.3,428.5z" />
            <path fill="#FC6585" d="M273.8,423.9c-0.4,0.3-1.1,0.4-0.5,0.8C273.5,424.4,273.7,424.2,273.8,423.9z" />
            <path
                fill="#FC6585"
                d="M270.7,416.2C269.5,416.8,270.2,417.5,270.7,416.2C270.8,416.3,270.7,416.2,270.7,416.2z"
            />
            <path fill="#FDA5BF" d="M266.8,394.3c-0.4,0.5,0.1,0.4,0.4,0.2C267.1,394.4,266.9,394.4,266.8,394.3z" />
            <path fill="#FC6585" d="M250.3,429.1c0.3-0.2,0.7-0.3,1-0.5C251,428.7,250.6,428.9,250.3,429.1z" />
            <path fill="#FC6585" d="M253.9,427c0.3-0.2,0.7-0.3,1-0.5C254.5,426.7,254.2,426.8,253.9,427z" />
            <path fill="#FC6585" d="M273.8,423.9c0.1,0,0.1-0.1,0.2-0.1C273.9,423.9,273.8,423.9,273.8,423.9z" />
            <path fill="#FC6585" d="M253.4,427.5c0.2-0.2,0.3-0.3,0.5-0.5C253.7,427.2,253.5,427.3,253.4,427.5z" />
            <path fill="#FC6585" d="M271.2,415.7c-0.1,0.2-0.5,0.4-0.4,0.6C270.9,416.1,271.5,415.9,271.2,415.7z" />
            <path fill="#FC6585" d="M271.3,415.8c0.1-0.1,0.1-0.2,0.2-0.3C271.3,415.6,271.1,415.7,271.3,415.8z" />
            <path fill="#FC6585" d="M249.8,429.6c0.2-0.2,0.3-0.3,0.5-0.5C250.1,429.2,249.9,429.4,249.8,429.6z" />
            <path fill="#FC6585" d="M272.7,414.7c-0.1,0.1-0.1,0.2-0.2,0.3C272.6,414.8,272.9,414.8,272.7,414.7z" />
            <path fill="#FC6585" d="M272.8,414.8c0.1-0.1,0.1-0.1,0.2-0.2C272.9,414.6,272.6,414.6,272.8,414.8z" />
            <path fill="#FD7FA1" d="M282,394.2c-1.5,0-3.1,0-4.6,0C279.1,396.3,285.7,397.8,282,394.2z" />
            <path fill="#FDA5BF" d="M283.6,396.2c-1.1,0-2.1,0.1-3.2,0.1C281.7,399.4,287.9,398.6,283.6,396.2z" />
            <path fill="#FD7FA1" d="M283.5,396.3c0.3,0.2,0.6,0.4,0.9,0.5C284.1,396.6,283.8,396.4,283.5,396.3z" />
            <path fill="#C1921A" d="M57.3,321.2c0.6,0.4,1.1,0.7,1.7,1.1C59.1,320.8,58.5,320.5,57.3,321.2z" />
            <path
                fill="#FC6585"
                d="M216.4,388.7c-42.9,3.5-34.3,13.6-56.1-25.5c-4.5,0.5-2-5.9-6.1-5c-2.9,0.5-2.5-2.4-2.1-4.5
            C95.5,331,16.3,307.9,11.7,234.5c-0.8,34.7,19.3,70.8,47.6,87.8c34.3,26.2,89.2,29.5,108.6,71.7c-38.2,21.8-92.9,36.5-136.4,56.1
            c35.4,3.3,63.2-21.8,95.9-31.5c8.2,4.1,6.4-4.4,12.6-3c2.7-3.6,7.4-2,10.4-5.4c2.6,3.3,9.6,3.4,9-1.9c1.9-2.3,4.8,1.6,7.4-1.3
            c4.3-1.8,21.3-7.7,20-3.6c7.4-11.5,9.9-1.7,16.1-1.7c-0.2-3.9-0.8-4.4-4.9-5.4c-7.1-7.8,20.6-2.7,25.4-8.2
            C221,388.3,218.6,388.2,216.4,388.7z"
            />
            <path
                fill="#FDD9EC"
                d="M228.3,434.7c7.1,0-4.2-5.4-6.3,0.2c-1.3-0.6-2.8-1.7-3.8,1.1c-1.5,1.4-6.2,1.7-7.5,4.2
            c-2.1,4.1,19,0.4,17.5-5.7C228.2,434.5,228.2,434.6,228.3,434.7z"
            />
            <path fill="#FD7FA1" d="M261.5,421.8c0.2-0.2,0.3-0.3,0.5-0.5C261.8,421.5,261.7,421.7,261.5,421.8z" />
            <path
                fill="#FDA5BF"
                d="M150,203.5c7.6-11.2-1.2,0.7-4.2-1.5c-5.4,5.5-1.4,4.7-0.9,9.5c3.4,10.9,13.8,3,5.3-3.7
            C149.6,206.6,148.1,205.1,150,203.5z"
            />
            <path
                fill="#FD7FA1"
                d="M151,217.9c-6.6-0.6-6.1-17-11-6.6c4.9-2.2,5.9,8.5,9.4,12.2C150,221.6,150.5,219.7,151,217.9z"
            />
            <path fill="#C1921A" d="M184.6,238.3c3.1-1.6,1.8-5.5-0.2-7.1C182,233,184.4,235.8,184.6,238.3z" />
            <path fill="#FFEA6A" d="M159.3,281.7c0.4,0.5,0.7,1,1.1,1.6C160.1,282.7,159.7,282.2,159.3,281.7z" />
            <path fill="#FDD9EC" d="M215,371.8c-1.6-8.1-26.5-32.5-31.5-24.4C182.5,355.7,211.4,393.1,215,371.8z" />
            <path
                fill="#FDD9EC"
                d="M36.6,264.2c1.4-2.8-5.1-7.8-3.4-10.3c-7.3-4.1-1.4,10.5,0,14.1c9.4,18.5,26.3,31.7,43.8,39.8
            c9.9-4.6-9.2-9.2-13.1-13.7C54,285.8,44.1,276.2,36.6,264.2z"
            />
            <path fill="#FD7FA1" d="M262.9,393c0.8,0.7,1,0.7,1.5-0.1C263.8,392.1,263.6,392.3,262.9,393z" />
            <path fill="#FD7FA1" d="M242.2,385.3c-0.4,0.1-0.5,0.3-0.2,0.5C242.4,385.8,242.4,385.6,242.2,385.3z" />
            <path fill="#FDA5BF" d="M258.5,364.6c0,0.1,0.1,0.1,0.1,0.2C258.5,364.8,258.5,364.6,258.5,364.6z" />
            <path
                fill="#FC6585"
                d="M143.4,210.4c-0.9,0.2-1.8,0.5-3.4,0.9c1.8-4.2,4.1-6.7,6.5-10.4c-4.1,1.1-6.1,5-7.7,8.7
            c-20.3-36.1-27.8-11.8-45.4-25c-17-10.7-34.6-4.8-46.2,8.7c3.9,4.5-5.3,5.8-3.2,11.4c-1.1,0.4-2.1,0.8-3.5,1.3
            c4,9.7-9.3,10.5,1.5,13.9c-0.9,3.2-4.5-0.2-6.2,2.7c1.8,1.4,7.7,2.5,3.7,4.5c-6.1,2,8.3,3.5-1.2,5.9c8.4,4.4,1.4,6,7.9,8.9
            c-16,7.4,4-0.2,1.1,6.2c-2.8,4.1,4.5,1.9,3.9,5.8c13,9.9,21.6,30.3,40.5,34.5c-2.7-2-5.9-4.1-8.7-5.6c-12.9-9.8-19.6-32.2-27.4-40.9
            c-0.2-3.6,3.6-21.2,5.1-12.3c1-6.4,2.9-12.5,5.9-18.3c-0.4,0.3-0.9,0.6-1.3,0.9c12.4-18.9,26.3-19.4,40.7-2.8
            c18.3-10.6,34.5,0.6,42.9,18.2C151.2,220.6,143.1,217.3,143.4,210.4z"
            />
            <path
                fill="#FD7FA1"
                d="M57.5,235.7c-3.6,3.6-2,14.8,4,10.2c-0.4-7.3-1.2-29.7-3.9-11.7c3-5.6,1.9,1.4,2.1,4.5
            C58.8,237.6,58.2,236.7,57.5,235.7z"
            />
            <path fill="#C1921A" d="M103.4,207.5c-0.1-0.1-0.3-0.2-0.4-0.3C103.1,207.5,103.2,207.5,103.4,207.5z" />
            <path
                fill="#FD7FA1"
                d="M117.4,180c-15.4,15.6,6.4-2.1,21.5,29.5c6.4-10.1-11.5-13.4-9.8-22.6C129.8,183.6,120.8,180.1,117.4,180z"
            />
            <path fill="#FDA5BF" d="M57.5,235.7c0.6,0.9,1.3,1.9,2.1,3.1C60.2,234.3,59.1,228.5,57.5,235.7z" />
            <path fill="#FD7FA1" d="M146.5,200.9c1.1-1.4,4-2.6,4-4.2C147.5,197.3,139.8,202.8,146.5,200.9z" />
            <path fill="#FD7FA1" d="M82.1,281.6c-0.8-0.6-1.4-2-2.1-0.5C80.7,281.2,81.4,281.4,82.1,281.6z" />
            <path fill="#FD7FA1" d="M85.1,283.8c-0.3-0.2-0.6-0.4-0.9-0.7C84.4,283.4,84.7,283.6,85.1,283.8z" />
            <path fill="#FD7FA1" d="M83.2,282.7c-0.2-0.3-0.4-0.6-0.6-0.9C82.8,282.1,83,282.4,83.2,282.7z" />
            <path fill="#FD7FA1" d="M91.4,287.8c-0.2-0.2-0.4-0.3-0.7-0.5C90.9,287.5,91.2,287.7,91.4,287.8z" />
            <path fill="#C1921A" d="M129.6,206.1c0.2,0.2,0.4,0.4,0.6,0.6C130,206.5,129.8,206.3,129.6,206.1z" />
            <path fill="#FD7FA1" d="M83.6,282.7c-0.1-0.1-0.3-0.1-0.4-0.1C83.3,282.7,83.4,282.7,83.6,282.7z" />
            <path
                fill="#FDD9EC"
                d="M162.2,200.5c-3.9-4.3-9-7.6-8.6-13.5c-5.1-4.5-9.7-1.4-17.1-0.6c2.8,4.4,4.3,15.1,10.4,12.1
            c9.7-5.7-6,6.5,1.5,3.4c1.5-0.8,3.7-4.2,5-3c-11.2,7.1,7.2,20.3,0,6.9C154.2,214,165.8,205.1,162.2,200.5z"
            />
            <path
                fill="#030203"
                d="M112.8,170.8c4.1-9.4-8.9-17-15.3-7.6C87.3,177,109.1,189.1,112.8,170.8z M111.2,163.6c0.1,0,0.2,0,0.4,0
            C111.4,163.6,111.3,163.6,111.2,163.6z M99.3,164.8c0-1.2,0.9-2.4,1.8-3.1C107.3,160.9,100.1,172.2,99.3,164.8z"
            />
            <path fill="#FDA5BF" d="M228.3,434.7c0-0.1-0.1-0.1-0.1-0.2C228.2,434.5,228.3,434.6,228.3,434.7z" />
            <path fill="#FDD9EC" d="M163.9,229.6c0.9,2.3,2.1,9.4,5.1,6.1C169.4,231.4,162.4,219.6,163.9,229.6z" />
            <path
                fill="#030203"
                d="M193.4,250.8c1.3-13-5.5-25.2-14.7-35.6c-10-18.2-25.8-8.5-29.3,8.3c3.8,19,5.9,39.1,9.9,58.2l0,0
            C177.8,306.7,198.3,269.9,193.4,250.8z M166.2,225.2c0-0.2-0.1-0.3-0.1-0.5C166.1,224.8,166.1,225,166.2,225.2z M165.8,224.1
            c-0.1-0.2-0.3-0.4-0.5-0.6C165.5,223.7,165.6,223.9,165.8,224.1z M165,223.4c-0.2-0.1-0.3-0.2-0.5-0.2
            C164.7,223.3,164.9,223.4,165,223.4z M163.4,222.9C163.4,222.9,163.4,222.9,163.4,222.9L163.4,222.9
            C163.4,222.9,163.4,222.9,163.4,222.9z M161.8,227.4c0.1-0.1,0.3-0.2,0.4-0.2C162,227.3,161.9,227.4,161.8,227.4z M154.4,213.5
            C154.4,213.5,154.4,213.5,154.4,213.5c1.5,1.4,2.4,3.2,3.1,5.1C156.9,216.7,156,215,154.4,213.5z M165.3,237.4
            C165.2,237.4,165.2,237.4,165.3,237.4C165.2,237.4,165.2,237.4,165.3,237.4C165.3,237.4,165.3,237.4,165.3,237.4
            c0.1,0.5,0.3,1,0.4,1.5C165.5,238.4,165.4,237.9,165.3,237.4z M164.8,235C164.8,235,164.8,235,164.8,235c0,0.1,0,0.1,0,0.2
            C164.9,235.2,164.8,235.1,164.8,235z M169,235.7c-5,5-7.9-18.2-2.1-7.2c0,0,0,0,0,0c0.3,1.3,1.6,2.2,2.1,3.3
            c-0.2-0.6-0.7-1.2-1.4-1.7c0.8,2.7,1.6,5.3,1.7,8.1C169.2,237.3,169.1,236.5,169,235.7z M169.1,232.2c0,0,0-0.1,0-0.1
            C169.1,232.1,169.1,232.1,169.1,232.2z"
            />
            <path fill="#FDD9EC" d="M102.3,166.8c1.6-1.5,2-6-1.2-5.1C98.8,162.9,98.4,168.8,102.3,166.8z" />
            <g>
                <path
                    fill="#C0FF02"
                    d="M184.2,56.2c-28.4,0-50.6,20.4-50.6,46.7s22.2,46.7,50.6,46.7s50.6-20.4,50.6-46.7S212.6,56.2,184.2,56.2z
                 M184.2,117.6c-7.8,0-14-6.3-14-14s6.3-14,14-14s14,6.3,14,14S192,117.6,184.2,117.6z"
                />
                <path
                    fill="#C0FF02"
                    d="M292.5,56.2c-28.4,0-50.6,20.4-50.6,46.7s22.2,46.7,50.6,46.7s50.6-20.4,50.6-46.7S320.9,56.2,292.5,56.2z
                 M292.5,117.6c-7.8,0-14-6.3-14-14s6.3-14,14-14s14,6.3,14,14S300.2,117.6,292.5,117.6z"
                />
                <path
                    fill="#C0FF02"
                    d="M386.4,57.6h-34.3v90.7h37.3v-25.8h1.3c22.4,0,42-9.4,42-32.7C432.7,63.8,408.2,57.6,386.4,57.6z M390.5,99.4
                h-1V84.1h1c6.3,0,9.4,3.4,9.4,7.6S396.8,99.4,390.5,99.4z"
                />
                <path
                    fill="#C0FF02"
                    d="M503.6,100.5c-8.9-7-21.4-8.5-25.2-9.6c-1.5-0.5-2.9-1.3-2.9-3.1c0-1.4,1-2.8,4.6-2.8c4.6,0,15.7,2.1,27.4,8
                V63.3c-8.3-4.3-21.3-7.1-32.3-7.1c-22.9,0-37,12.4-37,30.6c0,8.8,3.3,14.7,8,18.9c9.3,8.1,21.9,9.5,26.3,10.7
                c1.6,0.4,2.8,1.1,2.8,2.9c0,1.5-0.9,3-4.6,3c-5.4,0-17.7-2.9-29.8-10.8v30.8c8.9,4.6,22.6,7.4,34,7.4c23.8,0,37.8-12.2,37.8-29.6
                C512.8,111.9,509.7,105.6,503.6,100.5z"
                />
                <path
                    fill="#C0FF02"
                    d="M537.8,118.2c-9.6,0-17.5,7-17.5,15.7c0,8.8,7.9,15.9,17.5,15.9s17.5-7.1,17.5-15.9
                C555.4,125.2,547.5,118.2,537.8,118.2z"
                />
                <path
                    fill="#C0FF02"
                    d="M537.8,115.1c4,0,8,0.4,12,1l8.1-58.5h-40.3l8.1,58.5C529.8,115.5,533.8,115.1,537.8,115.1z"
                />
            </g>
            <g>
                <path
                    fill="#FFFFFF"
                    d="M230,195.2c7.5,8.4,1.5-9.9-7.7-1.4c-6.9,8.3,3.3,18,0.5,26.7c-5.1,5.9-16-6-8.7-10.3c-7.2-2.1-5,8.7-1.2,11.4
                c6.5,6.8,14.7,2.8,12.5-6.8c-1-5.5-5-12.1-2.2-17.6C224.3,194.8,227.7,193.2,230,195.2z"
                />
                <path
                    fill="#FFFFFF"
                    d="M244.3,214.3c1.9-3.9,1-9.7-2.2-12.6c-6.2-3-20,22.7-10.3,23.5C237,223.4,242.1,219.5,244.3,214.3z M243,209.4
                c0.1,4.4-3.2,8.4-6.8,10.6C222.7,229.4,240.3,195.4,243,209.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M262.9,217.5c-0.8-1-0.8-0.3-1.2,0.5c-0.8,0.7-1.9,1.6-2.4,2.6c-2.2,2.3-5.6,4.6-8.9,4.8
                c-6-0.1-0.7-4.3,1.5-6.1c3.6-4.5,7.9-9.2,11.9-13c-0.5-2.4-2.9-1.9-4.7-1.6c-1.6-0.3-3.4-0.3-4.8-0.6c-3.3-1.7-4.5,1.7-1.5,3.4
                c1.1-0.3,5.6-0.8,4.9,0.7c-4.5,5.8-10.1,11.6-15.4,15.6c-0.5,2.5,0.9,3.6,3.3,3.2C252.2,230.3,262,224.2,262.9,217.5z"
                />
                <path fill="#FFFFFF" d="M266.6,222.7c-1.1,2.2-7.1,13.8-1.5,14.2C262.4,232.8,272.9,223,266.6,222.7z" />
                <path
                    fill="#FFFFFF"
                    d="M284.4,229.7c0.7,3.8,3.6,5,6.5,2.5c2.3-1.9,7.4-3.7,7-7c-2.9,0.3-12,10-10.6,2.1c1.4-4.4,4.9-15.7,10.8-13.5
                c3-3.6-2.5-5.4-5.2-3.2C289.8,216.1,284,222.9,284.4,229.7z"
                />
                <path
                    fill="#FFFFFF"
                    d="M299.7,234.8c4.7,4.4,9.2-5.2,12.7-7.9c1.3-1.4-2.1,7.6-1.7,8.7c0.5,3.2,3.9,3.6,5.1,0.5
                c-0.6-2.3-2.3,0.7-2.2-1.3c0.9-6.6,3.3-13.1,7.2-18.4c-0.1-2.1-2.3-2.5-3.7-1.2c-0.2-0.4-0.3-1.7-0.9-1.6
                C308.5,210.3,296.7,227.6,299.7,234.8z M301.7,231c0.9-5.3,4.9-9.7,8.8-13.2c3-2.5,7.6-1.1,4.2,2.8
                C313.1,222.2,301.7,237.4,301.7,231z"
                />
                <path
                    fill="#FFFFFF"
                    d="M333.8,238.3c-5.3-2.4,8.2-16.2,5.3-20.5c-3.6-0.7-11,6.8-14.2,9.4c0.5-2.2,5.3-10,5-11.7
                c-0.6-2.1-3.4-2.4-3.7,0.1c0.5,6.3-8.7,15.5-7.4,20c2.2,3.3,5.1-4.7,6.9-5.7c2.6-2.4,6.3-5.2,8.9-7.3c2.2-1-5.2,11.8-5.5,14.7
                C329.1,240.7,332.7,241.6,333.8,238.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M340.4,250.2c7.2,13.1,18.3,0.6,21.2-8.7c3.3-5.4,11.1-29.6-0.7-13.8c-12.6,12.2-10.1,3.2-3.7-6.3
                c-1.3-9.7-9.5,12-8.1,14.6c3.4,4.5,11-4.6,14.1-6.8c-0.9,6.3-3.4,12.8-7.3,17.7c-1.8,4.7-8.1,9.3-12.3,4.4
                c-1.5-1.4-1.6-3.8-2.4-5.6C339.5,246.5,340.1,248.9,340.4,250.2z"
                />
                <path
                    fill="#FFFFFF"
                    d="M366.4,242.5c2.1,10.2,16.1-3.9,16.7-9.2C383.9,209.5,366.6,231.3,366.4,242.5z M369.3,241.1
                c0.6-5.1,4.5-12.2,8.8-14.5c3,2.2,3.3,1.1,2.8,6C381,235.8,370.3,246.6,369.3,241.1z"
                />
                <path
                    fill="#FFFFFF"
                    d="M382.5,246.5c2.8,3.8,4.8-2.7,7.3-3.6c2.6-2.2,6.8-5.8,9.1-8.1c-0.3,0.5-3.8,7.5-3.7,7.9
                c-7.6,18.2,15.7-3.8,5.2,1.9c-7.6,5.7,0.5-6.5,1.3-10c0.7-2.2,6-6.1,2.5-7.3c-2.8-1.7-3.8,4.2-5.8,5.5c-3,2.3-6.3,6.5-10,7.9
                c-4.8,4.1,1.7-7,2.6-9.1c1.1-1.8,3.6-2.9,3.6-5.3C389.9,222,382.8,242.7,382.5,246.5z"
                />
                <path
                    fill="#FFFFFF"
                    d="M406.7,256.5c1.1-6.3-5.6,3.4-1.9,6.3c3.3,3.4,8.5,3,12.3,0.8c5.4-4,7.8-10.6,9.8-16.8c1-2,3.3-7.3,4.2-9.4
                c1.2-0.7,2.8-2.4,2-3.9c-5.8-9.3-15.4,1.1-17.9,8c-6.8,17.3-0.7,12.5,9.5,4.1c-2.3,5.5-4.3,12.5-9.5,15.9
                C411.3,264.6,403.2,262.3,406.7,256.5z M428.9,233.6c-0.6,6.9-7.4,12.4-13.3,15C415.7,244.2,424.5,228.5,428.9,233.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M432.8,250.3c-3.2,4.6,0.3,10.7,2.7,3.1c-2.2-4.2,8.3-15.3,7.2-20.4c-4.4-2.6-3.1,3-4.4,5.5
                C436.7,242.4,434.1,246.2,432.8,250.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M445.2,227.8c1.3,2.4,3,0.4,2.5-1.6c0.8-0.2,2-0.5,2.7-1.1C447.5,222.1,442.4,222.7,445.2,227.8z"
                />
                <path
                    fill="#FFFFFF"
                    d="M445.6,256.6c2.9,0,3.2-5.6,5.7-7.2c3.4-4.8,8.5-8.7,12.8-12.6c-6.3-1.8-11.3,7.7-15.3,11.7
                c-2.5,2.4,2.2-12.6,2.2-14.5c-4.2-7.6-4.7,12.3-5.4,13.4C445.6,250.2,442.5,254.8,445.6,256.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M461.8,245c-13.1,27.8,18.5,10.9,11.3,6.9c-1.9,3.1-11.5,9.7-11.8,2.6c-0.2-3.5,1.8-2,4.3-2.6
                c7.2-2.1,16.2-15.8,4-16.2c-1.5,0.5-2.1,1.7-2.5,3C465.3,240.2,463.3,243.1,461.8,245z M463,248.6c2.1-3.9,4.9-7.3,9.1-9
                C476,243.1,459.2,254.8,463,248.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M478.7,272.4c12.4,14.3,22.2-11.5,24.9-21.3c0.4-1.7,0.8-4.1,1.9-5.6c0-2.3-2.8-3.1-3.7-0.8
                c-3,4.2-7.3,8-11.8,10.5c-2.5-5.2,6.1-10,4.4-15.2c-3.6-0.7-4.3,5.7-5.5,8.1c-3.2,3.9-3.5,13.8,3.5,8.9c1.9-1.8,4.4-3.3,6.5-4.7
                c0.3-0.3,2.4-3.1,1.9-1.6c-1,8.3-5.6,15.9-10.5,22c-4.1,3.4-10.4,1.1-10.8-4.4C477.8,264.2,477.1,271,478.7,272.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M504.1,263.4c2.1,10.2,16.1-3.9,16.7-9.2C521.6,230.4,504.3,252.2,504.1,263.4z M506.9,262
                c0.6-5.1,4.5-12.2,8.8-14.5c3,2.2,3.3,1.1,2.8,6C518.7,256.7,507.9,267.5,506.9,262z"
                />
                <path
                    fill="#FFFFFF"
                    d="M520.2,267.4c2.8,3.8,4.8-2.7,7.3-3.6c2.6-2.2,6.8-5.8,9.1-8.1c-0.3,0.5-3.8,7.5-3.7,7.9
                c-7.6,18.2,15.7-3.8,5.2,1.9c-7.6,5.7,0.5-6.5,1.3-10c0.7-2.2,6-6.1,2.5-7.3c-2.8-1.7-3.8,4.2-5.8,5.5c-3,2.3-6.3,6.5-10,7.9
                c-4.8,4.1,1.7-7,2.6-9.1c1.1-1.8,3.6-2.9,3.6-5.3C527.5,242.9,520.4,263.6,520.2,267.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M541.6,267.8c-2.1,2-2.3,4.3,0.4,5.9c1.6-1,1.7-2.5,2.3-4c1-3.3,4.3-6.7,6.7-9.1c2.5-2.1,5.8-3.8,9.1-4.2
                c3.9-0.1,0.5-2.9-1.8-2.2c-11.3,2.6-15.3,14.3-5.4-4.3c-0.4-2.5-3.5-3.2-4.8-1c0.1,1,0.3,2.5-0.2,3.4
                C545.7,257.1,543.1,262.8,541.6,267.8z"
                />
                <path
                    fill="#FFFFFF"
                    d="M573.8,271.9c1.2-4.8-2.3-15.6,3.9-17c1.1,1.1,3.4,1,3.2-1c-1.2-5.4-8-1.8-8.9,2.2c-1.7,5-0.4,10.2-1,15.3
                c-3.6,6-7.8,2.1-5.7-3.8c-0.7-3.5-1.5,2-2.6,2.8C560.8,278.5,572.8,279.3,573.8,271.9z"
                />
                <path
                    fill="#FFFFFF"
                    d="M595.5,257.5c-1.3-3.8-7.7-5.3-8.5-0.5c-5.3,4.7-12.2,15.4-6,21.8c3.7,2.2,17.3-6.4,12-8.6
                c-1.9,3.1-11.5,9.7-11.8,2.6c-0.4-4.2,3.5-1.3,5.9-3.3C590.8,267.5,597.1,261.2,595.5,257.5z M582.8,266.7c2.1-3.9,4.9-7.3,9.1-9
                C595.8,261.3,579,272.9,582.8,266.7z"
                />
                <path
                    fill="#FFFFFF"
                    d="M616.1,263.3c1.8-1.1,1.2-3.5-0.7-4c-0.5,0.1-2,1.8-1.9,0.4c-6.1-7.7-23.2,15.6-16.1,21.3
                c5.4,0.3,8.3-6.5,12.1-9.7c-0.5,2.4-2.9,7.8-2,10.3c2,5.3,7.4-2.9,2.7-0.8c-0.2,0-0.1-0.8-0.2-0.9C611,274.2,612.6,268,616.1,263.3
                z M612.7,262.7c-2.5,5.5-8.2,10.5-12.3,14.4C592.5,280.3,607.8,255.9,612.7,262.7z"
                />
                <path
                    fill="#FFFFFF"
                    d="M644.4,278.6c-1.7-3.6-9.1,7.8-11.2,3.1c0.9-5.9,3.7-12.3,8.6-16c1.7-0.3,2.9,1.1,3.7-1.3
                c-4.2-7.8-8.7,4.6-9.2,1.5c-5.6-1.3-10.7,2.6-14.6,6.3c0.7-4.3,6.8-9,5.6-11.8c-1.4-2.7-5.4-1.2-4.3,1.8c0,1.6-1.6,3-1.6,4.6
                c-2.6,4.3-3.7,10.6-6.6,14.6c-1,1.4,1.8,4.9,2.9,2.9c1.9-4.7,4.9-10.2,9.6-13.4c2.5-1.7,5.8-3.1,8.9-3c-1.3,3.2-7.4,11.1-4.9,16.2
                c1.9,2.7,3.6,2.7,6,0.7C639.7,283,642.7,281.2,644.4,278.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M667.4,267.9c-2.4-2.8-5,1.7-7.2,2.7c-0.9-0.6-1,1.1-1.7,1.2c-2.4,0.5-3.4,3.3-5.5,4.3
                c-5.7,6.1,1.9-8.8,3.2-11.8c0.7-2.9,8.2-8.7,3.4-10.2c-5.4,5.1-7.6,16-11.6,23.1c-0.3,3.7-6.2,8.1-3,11.2c1.5,0,2.4-1.7,2.8-3
                c1.8-2.9,6.4-7.1,8.9-9.5c2.1-1,4-3.3,6.1-4.4c1.1,3.4-11.4,17.6-2.7,19.2c4.3-1.4,6.9-6.9,0.5-3.1
                C657.5,284.6,667.5,272.2,667.4,267.9z"
                />
                <path
                    fill="#FFFFFF"
                    d="M298.2,263.8c1.5-5.2-3.6-1.6-3.4-2.9c-6.1-7.7-23.2,15.6-16.1,21.3c5.1,0.3,8-6.1,11.6-9.1
                c1.6-2.5-1.6,6.1-1.3,5.9c-1.7,3.7,2.3,8.3,4.6,3.4c-0.6-2.3-2.3,0.7-2.2-1.3C292.5,275.2,293.8,268.2,298.2,263.8z M294,263.9
                c-2.5,5.5-8.2,10.5-12.3,14.4C273.8,281.5,289.1,257.1,294,263.9z"
                />
                <path
                    fill="#FFFFFF"
                    d="M311,280.4c8.1-16.8,10.6-22.7-7.5-8.1c-2.5,4.4,3.6-8.3,3.3-8c0.5-0.4,1.5-0.9,1.1-1.7
                c0.1-3.6-4.2-3.2-3.9,0.3c-0.8,5.5-4.7,11.5-7.4,16.2c-0.6,7.4,4.4,0.9,5.9-1.7c3.2-3.4,7.5-6.8,11.2-9.3
                c-1.6,5.2-8.1,12.7-5.7,18.1c1.6,1.1,3-0.3,3.6-1.8C309.1,284.2,310.6,282.2,311,280.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M330.3,265.5c-6.3-6.2-18.2,16.9-13.6,22C326.3,289,336.7,274.3,330.3,265.5z M330,272.1
                c0.1,5.9-5.8,11.4-11.2,12.4c-2.1-5.7,4-12.5,7.7-16.2C329.3,270.3,329.7,268.5,330,272.1z"
                />
                <path
                    fill="#FFFFFF"
                    d="M346.4,284.6c-2.4-3.6-12.8,8.4-10.3-0.9c7.6-18.1,5-7.9,16.8-14.5c-1.9-1.3-10.2,1.6-8.2-1.6
                c1.1-1.8,3.5-3.8,3.5-5.9c-2.6-4.5-3.4,0-4.4,2.5c-3.4,7.6-4,3.3-6.7,6.5c2.7,3.8-2.4,8.2-3.3,12.6
                C329.3,295.3,342.1,289.3,346.4,284.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M368.6,273.1c-1-4.7-5.3,0.5-7.4,1.6c-0.9-0.6-1,1.1-1.7,1.2c-2.4,0.5-3.4,3.3-5.5,4.3
                c-5.7,6.1,1.9-8.8,3.2-11.8c0.7-2.9,8.2-8.7,3.4-10.2c-5.4,5.1-7.6,16-11.6,23.1c-0.3,3.7-6.2,8.1-3,11.2c1.5,0,2.4-1.7,2.8-3
                c1.8-2.9,6.4-7.1,8.9-9.5c2.2-1.1,4.1-3.7,6.6-4.6c-0.9,5-11.2,17.4-3.2,19.3c3-1,7.6-6.2,1.4-3.8
                C357.2,293.9,367.6,275.2,368.6,273.1z"
                />
                <path
                    fill="#FFFFFF"
                    d="M383.3,287.7c-1.2-0.5-2.1,0.8-2.6,1.6c-0.9,0.8-3.7,2.3-4.5,3.2c-2.1,1.5-6.8,1.3-6.1-2.2
                c-0.4-5,7.3,0.9,13.7-11.3c2.7-3.7-1.3-8-5.4-7.5c-2,0.5-1.7,2.6-3.2,3.4c-5.7,4.6-13.8,23.8-0.4,21.2
                C378.3,294.4,383.3,292.1,383.3,287.7z M371.9,284.3c0.5-2,9.1-12,9.8-7.7C381.8,280.3,368.6,290.1,371.9,284.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M405.3,281.6c-1.4-3.8-7.4-0.1-10.1,0.9c-1.5,0.7-6.4,6.6-4,2.2c0.8-3.9,9.2-9.7,2.1-11.5
                c-1.9,0.9-1.7,2.5-1.7,4.2c-0.8,1.7-1.5,3.8-2.4,5.5c-1,3-3.5,7.5-4.1,10.7c-2.1,2-2.3,4.3,0.4,5.9
                C390.7,290.1,393.5,283.9,405.3,281.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M423.1,289.2c5.4-3.6-1.6-3.2-4.5-2.6c1.7-5.1,4.6-10.4,8.4-14.1c2.5-2.8,2.9,2.1,3.4,3.7
                c3.1,0.4,1.9-3.4,1-5.1c-1.9-11.9-14.2,10.6-15.2,14.4c-1,3.2-5.9-0.7-7.6,1.9c2.3,7.8,10.8-6.8,0.6,13.6c-1.5,1.3-2.4,7.9-4.6,6.8
                c-2.2,1.7-0.6,7,2,4.2c2.7-5.4,5.7-11,8.1-16.5C415.9,290.6,418,287.7,423.1,289.2z"
                />
                <path
                    fill="#FFFFFF"
                    d="M434.1,297.3c-0.9-2.6-5.6,2.7-7.7,3.3c-0.8-7.5,7.9-18.6,11.6-26.3c1.4-0.5,1.5-2.4,0.5-3.4
                c-3.1-1.8-6.7,10.3-8.4,12.2C424,292.8,416.2,315.9,434.1,297.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M454.8,287.6c1.5-5.2-3.6-1.6-3.4-2.9c-6.1-7.7-23.2,15.6-16.1,21.3c4.8,0.7,6.9-5.3,10.4-7.6
                c3.6-5.6-0.1,3.3-0.1,4.4c-1.7,3.7,2.3,8.3,4.6,3.4c-0.6-2.3-2.3,0.7-2.2-1.3C449.1,299,450.4,292,454.8,287.6z M450.6,287.6
                c-2.5,5.5-8.2,10.5-12.3,14.4C430.4,305.3,445.7,280.8,450.6,287.6z"
                />
                <path
                    fill="#FFFFFF"
                    d="M484.1,292.6c2.3-1.6,3.8-6.8-0.5-5.4c-2,3.5-6.7,5.6-9.3,8.8c-2.1,1.2-4.7,3.9-6.5,5.3
                c0.5-1.1,1.8-4.2,2.5-5.1c7.2-16.5-5.4-5.2-10.8,0.6c-0.6,0,2.5-6.6,3-7.5c1.4-1.3,2.9-2.5,1.4-4.5c-3.9-2.9-8.8,17.2-10.5,20.2
                c2.3,5.7,4.5-3.6,6.7-4.8c3.3-3.7,13.4-15.6,6.3-2c-0.4,2.9-4.4,6.5-3,9.2c0.6,2.8,14.1-12.4,16.8-13.5c-2.8,4.3-5.2,9.3-6.9,14.1
                c-0.5,2.2,1.2,4.6,3.4,2.8c0.1-1.1-1-2.5-0.4-3.9C478,301.9,480.9,297.1,484.1,292.6z"
                />
                <path fill="#FFFFFF" d="M500.1,283.2c4.3-1.5-7.1-5.5-4.2,0.9C499.4,290,497.8,282.6,500.1,283.2z" />
                <path
                    fill="#FFFFFF"
                    d="M493.1,293.7c3.8-3.6-3.8-5.9-2.7-1.8c-1,7.8-8.5,14.2-7.7,22.3c2.2,1,5-2.8,3-4.1
                C487.6,304.8,491,298.9,493.1,293.7z"
                />
                <path
                    fill="#FFFFFF"
                    d="M511.5,293c-3.7,3.1-9.8,6.4-13,10.1c0.5-3,6.6-10.3,4.4-12.9c-3.9-2.3-2.6,3.6-3.9,5.5
                c-0.8,4.6-7.9,12.3-6.5,15.8c1.6,3.3,4.7-3.5,5.7-4.3c1.1-1.7,3.4-2.8,4.5-4.4c1.4-0.9,4.6-3.3,5.6-4.2c3.3-0.4-10.5,16.2-3.2,17.9
                c4.8-3.2-0.4-1.6,1-4.5C506.3,306.8,516.5,296.5,511.5,293z"
                />
                <path
                    fill="#FFFFFF"
                    d="M532.6,306.4c10.8-1.3-17.1-5-17-1.7c-0.3,3.7,3.9,1.7,6.1,1.5C525,305.9,529.2,305.9,532.6,306.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M554.5,304.5c2-2.1-0.3-3.3-1.2-5.1c-3.4-4.1-8.7,0.1-11.5,2.9c-4.8,5.3-14,28.5,0.5,14.9
                c9.4-9.3-0.3,8.3-3.5,11.3c-3.5,4.2-13.7,2.9-10-3.9c1.3-7.3-9.3,7.4,3.6,8.9C547.4,333.5,546.7,313.2,554.5,304.5z M551,301.7
                c-0.6,6.9-7.4,12.4-13.3,15C537.8,312.3,546.6,296.6,551,301.7z"
                />
                <path
                    fill="#FFFFFF"
                    d="M567.9,301.5c-6.3-6.2-18.2,16.9-13.6,22C563.9,325,574.3,310.4,567.9,301.5z M567.5,308.2
                c0.1,5.9-5.8,11.4-11.2,12.4c-2.1-5.7,4-12.5,7.7-16.2C566.8,306.4,567.2,304.6,567.5,308.2z"
                />
                <path
                    fill="#FFFFFF"
                    d="M588.7,294.3c-4.1-0.9-15.7-0.8-12.9,6c2-0.5,2.8-2.9,4.9-3.6c6.5-1.2,7-0.3,2.4,4.4c-4,3-13.2,14.4-3.9,15.8
                C572.5,306.9,593.3,301.2,588.7,294.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M578.7,322.4c-2.2,0.2-8.3,0.8-5.2,4.2c1.6,1.3,2.4-1.3,3.9-1.3C579.1,324.3,583.3,323.1,578.7,322.4z"
                />
            </g>
            <path
                fill="none"
                d="M-377.7,221.2c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0.1-0.1,0.2-0.2,0.3C-377.7,221.2-377.7,221.2-377.7,221.2z"
            />
            <path
                fill="none"
                d="M-417.1,253.2c0,0.1,0,0.1,0.1,0.1l0.1,0.1c0,0,0,0,0,0C-417,253.4-417,253.3-417.1,253.2z"
            />
            <path
                fill="none"
                d="M-290.6,203.4c-0.3-0.1-0.5-0.2-0.8-0.2c0.6,1.2,1.4,2.4,2.2,3.5C-289.7,205.5-290.2,204.4-290.6,203.4z"
            />
            <path fill="none" d="M-377.1,220.3c0.4-0.1,0.7,0.8,0.8,2.2C-376.2,220.9-376.4,219.6-377.1,220.3z" />
            <polygon fill="none" points="-289.7,162.7 -289.7,162.7 -289.7,162.7 -289.7,162.7 " />
            <path
                fill="none"
                d="M-282,176.7c-0.1-0.2-0.2-0.3-0.3-0.5c0,0.4,0.1,0.9,0.2,1.3C-282.2,177.2-282.1,176.9-282,176.7z"
            />
            <path fill="#FD7FA1" d="M-324.6,197.5c-0.1-0.1-0.3-0.2-0.4-0.3C-324.9,197.5-324.7,197.5-324.6,197.5z" />
            <path fill="#FD7FA1" d="M-344.4,272.7c-0.1-0.1-0.3-0.1-0.4-0.1C-344.7,272.7-344.5,272.7-344.4,272.7z" />
        </svg>
    );
}
